
export enum BillingActivityStatus {
    None = 0,
    Pending = 1,
    Paid = 2,
    Fail = 3,
    // Fictitious, only validate
    WithoutConfig = 10,
    WithoutPlan = 11,
    WithoutRecurrence = 12
}

export enum FormStatus {
    None = 0,
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Hold = 4
}

export enum OrderStatus {
    None = 0,
    Pending = 1,
    PaidOrExchanged = 2,
    Draft = 3,
    PaidManual = 4,
    Active = 5, // recurrence
    PreOrder = 6, //
    Preparing = 7, //
    ExpiredNatural = 8,
    ExpiredPreOrder = 9,
    Anulado = 10 //
}

export enum DisabledType {
    None = 0,
    Locked = 1,
    Preregister = 2,
    ClientRequest = 3,
    Deleted = 4,
    Other = 10
}

export enum PackageSearchType {
    All = 0,
    AppPublic = 5,
    AppPrivate = 6
}

export enum ShippingType {

    ShippingRequired = 1,
    ShippingOrStoreDelivery = 2,
    StoreDelivery = 3,
    WithoutShipping = 4,
    Other = 5,

    // For show in list UI
    ShippingExpress = 9,
}

export enum HaciendaType {
    None = 0,
    Tradicional = 1,
    Simplificado = 2,
    NoInscrito = 3
}

export enum BillingStatementStatus {
    None = 0,
    PendingPayment = 1,
    Paid = 2,
    PendingInvoice = 3,
    OverdueInvoice = 4,
    OverduePayment = 5
}

export enum SocialNetworkType {

    None = 0,
    Facebook = 1,
    Instagram = 2,
    Twitter = 3,
    Youtube = 4,
    Pinterest = 5
}

export enum VariantType {
    List = 1,
    Color = 2,
}

export enum CategoryType {

    None = 0,
    Deals = 1,
    GiviGifts = 2,
    GiviPops = 3,
    Other = 4,
    Giver = 5,
}

export enum ThematicType {

    None = 0,
    Main = 1,
    Sub = 2,
    Other = 4,
}

export enum EventFormatType {
    None = 0,
    OnLine = 1,
    InPerson = 2,
    Membership = 3,
    Other = 10
}

export enum AudiencesType {
    None = 0,
    Adults = 1,
    AllPublic = 2,
    Familiar = 3,
    BoysAndGirls = 4,
    Other = 10
}

export enum GenderType {
    None = 0,
    Male = 1,
    Female = 2,
    Undefined = 3
}

export enum IdCardType {
    None = 0,
    Fisica = 1,
    Juridical = 2,
    Otros = 3, // Extranjero
}

export enum IdCardCustomerType {
    None = 0,
    Nacional = 1,
    Dimex = 2, // Residente
    Foreign = 3, // Extranjero
}

export enum CustomerType {
    None = 0,
    GiviUser = 1, // Solo puede entrar al GiviApp o GiviWeb
    GiviUserAndGiviScan = 2,
    GiviScan = 5, // Solo puede entrar al GiviScan
}

export enum ProductTaxType {
    Exempt = 0,
    IVA_01 = 1,
    IVA_02 = 2,
    IVA_13 = 13
}

export enum PaymentMethodType {
    None = 0,
    All = 1,
    VisaAndMasterCard = 2,
    Amex = 3
}

export enum PayType {
    None = 0,
    Card = 1,
    Transfer = 2,
    CardPoints = 4
}

export enum KnowsUsByType {
    None = 0,
    Facebook = 1,
    Instagram = 2,
    Newspaper = 3,
    Referred = 4,
    Tv = 5,
    Other = 6
}

export enum SaleStatus {
    Pending = 0,
    Preparing = 1,
    ReadyToDeliver = 2,
    Delivered = 3
}

export enum PointTransactionType {
    All = 0,
    // TODO: Cambiar valores de 10 a 50
    PurchasePoints = 1,
    PurchaseProducts = 2,
    PurchaseGiftcards = 3,
    PurchaseCoupons = 40,
    PurchaseCouponPoints = 41,
    PurchaseEventTickets = 15,
    PurchaseCashlessItems = 16,
    PurchasePassTickets = 17,
    PurchasePackages = 18,
    PurchaseScratch = 19,

    // TODO: Cambiar valores de 100 a 150
    ReceivedPoints = 4,
    ReceivedProducts = 5,
    ReceivedGiftcards = 6,
    ReceivedCoupons = 70,
    ReceivedCouponPoints = 141,
    ReceivedEventTickets = 25,
    ReceivedCashlessItems = 126,
    ReceivedScratch = 127,
    //ReceivedPackages = 128,
    ReceivedPassTickets = 129,

    // TODO: Cambiar valores de 200 a 250
    ExchangeProducts = 7,
    ExchangeGiftcards = 8,
    ExchangeCoupons = 9,
    ExchangeCouponPoints = 241,
    ExchangeEventTickets = 35,
    ExchangeCashlessItems = 236,
    ExchangePassTickets = 237,
    //ExchangePackages = 238,
    ExchangeScratch = 239
}

export enum VendorDiscountType {
    Custom = 0,
    PERCENT_08 = 8,
    PERCENT_10 = 10,
    PERCENT_12 = 12,
    PERCENT_14 = 14,
    PERCENT_15 = 15,
    PERCENT_16 = 16,
    PERCENT_18 = 18,
    PERCENT_20 = 20,
    PERCENT_22 = 22,
    PERCENT_24 = 24,
}

export enum CurrencyType {
    CRC = 0,
    USD = 1,
    PAB = 2,
    MXN = 3,
    COP = 4,
    NIO = 5,
    GTQ = 6
}

export enum EventType {
    None = 0,
    // Event
    EventWithExpirationDate = 1,
    EventWithOutExpirationDate = 2,
    // Cashless
    CashlessWithExpirationDate = 21,
    CashlessWithOutExpirationDate = 22,
    // Pass
    PassWithExpirationDate = 31,
    PassWithOutExpirationDate = 32
}

export enum EventStatus {
    Inactive = 0,
    Active = 1,
    ActiveHidden = 2,
    Deleted = 3
}

export enum TransactionCouponType {
    None = 0,
    Transaction = 1,
    Unique = 2,
    Multiple = 3
}

export enum CouponType {
    None = 0,
    MassiveLink = 1, // Cupón Único
    IndividualLink = 2, // Cupón Multiple
    PointsLink = 5 // givi cash links
}

export enum CouponApplicationType {
    None = 0,
    General = 1, // Cupón para uso general en el app
    Experiences = 2, // Cupón para tickets en experiencias
}

export enum LinkStatus {
    None = 0,
    Send = 1,
    Accepted = 2
}

export enum GiviType {
    None = 0,
    Product = 1,
    Giftcard = 2,
    Donation = 3,

    CouponPoints = 5,
    CouponUniqueLink = 6,
    CouponMultipleLink = 7,
    Scratch = 8,

    Events = 10,
    Tickets = 11,
    Cashless = 12,
    Pass = 13
}

export enum ExpirationType {
    None = 0,
    QuantityAndHours = 1,
    Hours = 2,
    Quantity = 3
}

export enum CommunityType {
    None = 0,
    Public = 1,
    Private = 2
}

export enum PurchaseType {
    None = 0,
    // Se compra en el app mobile normalmente (logueado)
    GiviApp = 1,

    // Se compra en migivi normalmente (logueado)
    GiviWeb = 5,
    // Compra sin loguearse, con numero teléfono, (generalmente se crea cuenta)
    GiviWebCheckoutExpress = 6,

    // Se hace por link (regalo)
    HolaGivi = 10,
    // Compra sin loguearse, con numero teléfono, (generalmente se crea cuenta)
    HolaGiviCheckoutExpress = 11,

    // Se hace por Misticket
    Mistickets = 15,

    // Se hizo directo en la BD
    Manual = 20
}

export enum RedeemedType {
    Link = 0,
    // Se canjea en el app (GiviScan)
    GiviApp = 1,
}

export enum AssignedType {
    None = 0,
    Sms = 1,
    Link = 2,
}

export enum AttachmentType {
    None = 0,
    Image = 1,
    Video = 2,
    Document = 3
}

export enum BuyerType {
    None = 0,
    Customer = 1,
    Company = 2
}
export enum VendorProfileImageType {
    None = 0,
    Instagram = 1,
    Facebook = 2,
}

export enum BitType {
    None = 0,
    Bit = 1,
    Points = 2,
    Scratch = 3
}

export enum CardStatus {
    None = 0,
    Valid = 1
}

export enum CardIssueType {
    None = 0,
    PurchaseMoreThan50k = 1,
    OverTwoPurchases = 2,
    DifferentCardholder = 3,
    SameDayAccountAndPurchase = 4,
    OutOfTime = 5
}

export enum CardIssueStatus {
    Pending = 0,
    Valid = 1,
    RejectedByInfo = 10,
    RejectedByFraud = 10
}

export enum StoreType {
    Exchange = 0,
    Spot = 1,
    RejectedByFraud = 11
}

export enum CommunitySearchType {
    All = 0,
    CMSPublic = 1,
    CMSPrivate = 2,
    AppPublic = 5,
    AppPrivate = 6
}

export enum LoyaltyPlanSearchType {
    All = 0,
    AppPublic = 5,
    AppPrivate = 6
}

export enum TransactionSearchType {
    All = 0,
    Pending = 1,
    Redeem = 2,
    Void = 10
}

export enum SearchSubType {
    All = 0,
    NormalBits = 1,
    Points = 2,
    Scratch = 3,
}
export enum SearchType {
    All = 0,
    Pops = 1,
    Experiences = 2,
    Coupons = 3,
    Packages = 4,
    Comunities = 5,
    Donation = 6,
    Giftcards = 7, // Pops and Donations
    Cashless = 8,
    Pass = 9
}

export enum BenefitsType {
    Giftcard = 'giftcard',
    Coupon = 'coupon',
    Product = 'product',
    Event = 'event',
    Cashless = 'cashless',
    Pass = 'pass',
    Scratch = 'scratch',

}

export enum InvitationStatus {
    None = 0,
    ClientRequest = 1,
    Refused = 2,
    Approved = 3
}

export enum GiftcardType {
    None = 0,
    POP = 1,
    Donation = 2,
    Merch = 3,
}

export enum GiveawayProductType {
    None = 0,
    Points = 1,
    Products = 2,
    Giftcards = 3,
    Coupons = 4,
    Tickets = 5
}

export enum GiveawayType {
    None = 0,
    Lotto = 1,
    Gift = 2
}

export enum AppType {
    GiviApp = 1,
    GiviWeb = 5,
    // Para cada compra se genera uno
    Checkout = 10
}

export enum Country {
    None = -1,
    CR = 1,
    PA = 2,
    MX = 3,
    CO = 4,
    NI = 5,
    GT = 6,
}

export enum VendorFormType {
    Survey = 1,
    Trivia = 2,
    Quiz = 3
}

export enum VendorFormQuestionType {
    MultipleChoice = 1,
    OpenText = 2
}

export enum AssignedStickerType{

    None = 0,
    Sticker = 1,
    Coupon = 2,
    Scratch = 3,
}

export enum ErrorCode {

    CreatedNotAllowed,
    UpdateNotAllowed,
    DeletedNotAllowed,
    RecordDuplicated,
    MissingParameters,
    NotFound,
    AlreadyUsed,
    NotInPlan,
}

export enum LoyaltyPlanQuestionType {
    None = 0,
    WriteAnswer = 1,
    SelectAnswer = 2,
}

export enum RewardType {
    Coupon = 1,
    Scratch = 2,
    Ticket = 3,
}
/**
 * Destino lógico de un archivo subido a S3. Debe mantenerse en sincronía con
 * UploadPurpose del API (GEG.Common.Enums): el backend resuelve la carpeta a partir
 * de este valor, el cliente ya no la arma.
 */
export enum UploadPurpose {
    ProductImage = 1,
    VendorProfile = 2,
    VendorPhoto = 3,
    MemberInvitation = 4,
    Coupon = 5,
    Pop = 6,
    Package = 7,
    VendorForm = 8,
    Event = 9,
    TransactionRefund = 10,
    Pack = 11,
    Scratch = 12,
    Loyalty = 13,
    CommunityBanner = 14,
    Ticket = 15,
    Billing = 16,
    PaymentConsolidated = 17,
    LoyaltyPlan = 18,
    Email = 19,
    FileStorage = 20,
    CustomerPhoto = 21,
    CustomerCard = 22,
    BitAttachment = 23,
}
